import React from 'react';
import { Stack } from '@mui/material';
import { ProgrammationDto } from '../store/programmation/programmation.models'
import ProgCard from '../components/progCard.component';
import Tache1 from '../assets/images/tache1.svg';
import Tache2 from '../assets/images/tache2.svg';
import Tache3 from '../assets/images/tache3.svg';

const Programmation = () => {

  const prog: ProgrammationDto[] = [
    {
      date: 'Mardi 31 mars 2026',
      location: 'Cité de la Musique',
      types: '[LIVE]',
      artists: [
        { name: 'Cinna Peyghamy', type: 'live' },
        { name: 'Elizabeth Vogler', type: 'live' },
      ],
      price: '9 / 13€',
      link: 'https://www.helloasso.com/associations/folks-festival/evenements/folks-cite-de-la-musique-cinna-peyghamy-et-elizabeth-vogler',
      time: '20h00-23h00'
    },
    {
      date: 'Mercredi 1 avril 2026',
      location: "Micro Kawa",
      types: '[DJ SETS COMMENTÉS]',
      artists: [
        { name: 'Mihaela Mîndru', type: 'dj set commenté & projections' },
        { name: 'Mona HKL', type: 'dj set commenté & projections' }
      ],
      price: 'Prix libre',
      link: 'https://www.helloasso.com/associations/folks-festival/evenements/folks-micro-kawa-mona-hkl',
      time: '18h30-22h00'
    },
    {
      date: 'Jeudi 2 avril 2026',
      location: "L'Embobineuse",
      types: '[LIVE]',
      artists: [
        { name: 'Arsenal Mikebe', type: 'live' },
        { name: 'MC KER·6', type: 'live' }
      ],
      price: '10 / 13€ + 2€ adhésion',
      link: 'https://www.helloasso.com/associations/folks-festival/evenements/folks-embobineuse-arsenal-mikebe-mc-ker6',
      time: '20h30-02h00'
    },
    {
      date: 'Vendredi 3 avril 2026',
      location: "L'Embobineuse",
      types: '[LIVE]',
      artists: [
        { name: 'HHY & The Kampala Unit', type: 'live' },
        { name: 'Nuèit', type: 'live' }
      ],
      price: '10 / 13€ + 2€ adhésion',
      link: 'https://www.helloasso.com/associations/folks-festival/evenements/folks-embobineuse-hhy-kampala-unit-nueit',
      time: '20h30-00h30'
    },
    {
      date: 'Vendredi 3 avril 2026',
      location: "UNITÉ.22",
      types: '[LIVE, DJ SETS]',
      artists: [
        { name: 'Cigarra' },
        { name: 'Le Frit', type: 'live' },
        { name: 'MC Yallah', type: 'live' }
      ],
      price: '11 / 13€',
      link: 'https://www.helloasso.com/associations/folks-festival/evenements/folks-unite-22-mc-yallah-cigarra-le-frit',
      time: '00h00-05h00'
    },
    {
      date: 'Samedi 4 avril 2026',
      location: "Petit Cab, Friche la Belle de Mai",
      types: '[LIVE, DJ SETS]',
      artists: [
        { name: 'Derbcore', type: 'live' },
        { name: 'DJ Travella' },
        { name: 'Kamoun' },
        { name: 'Nadia El Hakim' }
      ],
      link: 'https://shotgun.live/fr/events/folks-petit-cab',
      time: '23h00-05h00'
    }
  ]

  return (
    <Stack alignItems='center' justifyContent='center' gap={4} pt={4} pb={4} minWidth='80%' style={{position: 'relative', overflow: 'hidden'}}>
      <svg style={{position: 'absolute', width: 0, height: 0}}>
        <defs>
          <filter id="inkSplatterProg">
            <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="4" result="noise" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" xChannelSelector="R" yChannelSelector="G" />
          </filter>
        </defs>
      </svg>
      {/* Taches grunge décoratives - Clusters */}
      {/* Cluster 1 - haut gauche */}
      <img src={Tache2} alt='' style={{position: 'absolute', top: '5%', left: '8%', width: '46px', transform: 'rotate(25deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '7%', left: '10%', width: '33px', transform: 'rotate(-35deg)', zIndex: 999}} />

      {/* Cluster 2 - haut droite */}
      <img src={Tache3} alt='' style={{position: 'absolute', top: '15%', right: '12%', width: '41px', transform: 'rotate(-55deg)', zIndex: 999}} />
      <img src={Tache2} alt='' style={{position: 'absolute', top: '13%', right: '10%', width: '29px', transform: 'rotate(70deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '17%', right: '14%', width: '25px', transform: 'rotate(125deg)', zIndex: 999}} />

      {/* Cluster 3 - milieu gauche */}
      <img src={Tache1} alt='' style={{position: 'absolute', top: '30%', left: '5%', width: '44px', transform: 'rotate(-20deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '32%', left: '7%', width: '32px', transform: 'rotate(85deg)', zIndex: 999}} />

      {/* Cluster 4 - milieu droite */}
      <img src={Tache2} alt='' style={{position: 'absolute', top: '45%', right: '10%', width: '49px', transform: 'rotate(35deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '47%', right: '12%', width: '37px', transform: 'rotate(-65deg)', zIndex: 999}} />

      {/* Cluster 5 - centre gauche */}
      <img src={Tache3} alt='' style={{position: 'absolute', top: '60%', left: '15%', width: '40px', transform: 'rotate(-15deg)', zIndex: 999}} />
      <img src={Tache2} alt='' style={{position: 'absolute', top: '62%', left: '17%', width: '28px', transform: 'rotate(95deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '58%', left: '13%', width: '31px', transform: 'rotate(-75deg)', zIndex: 999}} />

      {/* Cluster 6 - bas droite */}
      <img src={Tache1} alt='' style={{position: 'absolute', top: '75%', right: '8%', width: '45px', transform: 'rotate(45deg)', zIndex: 999}} />
      <img src={Tache3} alt='' style={{position: 'absolute', top: '77%', right: '10%', width: '34px', transform: 'rotate(-40deg)', zIndex: 999}} />

      {/* Cluster 7 - très bas centre */}
      <img src={Tache2} alt='' style={{position: 'absolute', top: '88%', left: '22%', width: '42px', transform: 'rotate(-28deg)', zIndex: 999}} />
      <img src={Tache1} alt='' style={{position: 'absolute', top: '90%', left: '24%', width: '30px', transform: 'rotate(68deg)', zIndex: 999}} />

      {/* Taches isolées */}
      <img src={Tache3} alt='' style={{position: 'absolute', top: '22%', left: '28%', width: '39px', transform: 'rotate(-82deg)', zIndex: 999}} />
      <img src={Tache2} alt='' style={{position: 'absolute', top: '52%', right: '25%', width: '36px', transform: 'rotate(18deg)', zIndex: 999}} />
      <Stack gap={4} minWidth='80%' maxWidth='90%' alignItems='center' justifyContent='center'>
        {prog.map((it) => (
          <ProgCard programmation={it} />
        ))}
      </Stack>
    </Stack>
  )
}

export default Programmation;